import { Component, inject, input, output, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DxButtonModule } from 'devextreme-angular/ui/button';
import { DxLoadIndicatorModule } from 'devextreme-angular/ui/load-indicator';
import { ClickEvent } from 'devextreme/ui/button';
import { HttpStateService } from '~/app/core/services/backend/httpstate.service';
import { HttpProgressState } from '~/app/core/services/base/base.service';
import { endsWith } from 'lodash';

@Component({
  selector: 'app-button',
  template: `
    <dx-button
      class="app-button"
      [disabled]="disabled()"
      [width]="width()"
      [type]="type()"
      [stylingMode]="stylingMode()"
      [text]="label()"
      (onClick)="clickHandler($event)"
    >
      <div *dxTemplate="let data of 'content'">
        @if (loading()) {
          <dx-load-indicator class="button-indicator bobo"> </dx-load-indicator>
        } @else {
          <span class="dx-button-text">{{ label() }}</span>
        }
      </div>
    </dx-button>
  `,
  imports: [DxButtonModule, DxLoadIndicatorModule, TranslateModule],
})
export class AppButtonComponent {
  readonly label = input('');
  readonly disabled = input(false);
  readonly type = input('default');
  readonly stylingMode = input('contained');
  readonly hideLabelDuringLoading = input(false);
  readonly filterBy = input<string | null>(null);
  readonly filterEndsWith = input(false);
  readonly width = input<string | undefined>();

  protected readonly buttonClick = output<any>();

  readonly #httpStateService = inject(HttpStateService);

  readonly #loading = signal(false);
  protected readonly loading = this.#loading.asReadonly();

  ngOnInit() {
    this.#httpStateService.state.subscribe((progress) => {
      if (progress?.url) {
        const filter = this.filterBy();
        const isStart = progress.state === HttpProgressState.start;

        if (!filter) {
          this.#updateLoading(isStart);
        } else {
          const urlMatches = progress.url.indexOf(filter) !== -1;
          const urlEndsWith = endsWith(progress.url, filter);

          if (this.filterEndsWith() && urlEndsWith) {
            this.#updateLoading(isStart);
          } else if (!this.filterEndsWith() && urlMatches) {
            this.#updateLoading(isStart);
          }
        }
      }
    });
  }

  #updateLoading(value: boolean) {
    setTimeout(() => this.#loading.set(value));
  }

  protected clickHandler(event: ClickEvent) {
    if (!this.disabled() && !this.loading()) {
      this.buttonClick.emit(event);
    }
  }
}
